(function($) {
    // Plugin
    $.fn.dsInputRemovable = function(options) {
        // Loop through each requested element selector
        this.each(function(idx, e) {
            // Options
            var _this = $(e);
            var settings = $.extend({
                icon: "fa-times-circle",
            }, options);

            // Make sure we only run this on input[type="text"] and textarea
            var tag = _this[0].tagName.toLowerCase();
            if (tag !== 'textarea' && (tag !== 'input' || _this.attr('type') !== 'text')) {
                return;
            }

            // See if this guy has already been initialized
            if (_this.data('ds-input-removable') !== undefined) {
                return;
            }

            // Surround this element with a ds-input-removable span
            _this.data('ds-input-removable', settings);
            _this.wrap('<div class="ds-input-removable"></div>');

            // Add our delete icon
            var icon = $('<i class="fa ' + settings.icon + ' ds-remove-icon"></i>');
            icon.insertAfter(_this);
            icon.on('click', function () {
                // Remove the element
                _this.parents('.ds-input-removable').remove();

                // Trigger the event indicating that it happened so it can be listened to
                _this.trigger('ds.input.remove', [_this]);
            });
        });
    };
}(window.$));
